import { dedent } from 'ts-dedent'
import {
  QueryAndOutputs,
  WorkflowComponentCodeParams,
  WorkflowComponentInput,
  WorkflowComponentMetadata
} from '../../types'
import {
  SINGLE_OUTPUT_NAME,
  SingleOutputWorkflowComponent
} from './singleoutputcomponent'

// A workflow component that represents a transformation that can be expressed with a SELECT query
export abstract class SelectWorkflowComponent extends SingleOutputWorkflowComponent {
  constructor(
    metadata: WorkflowComponentMetadata,
    inputs: WorkflowComponentInput[]
  ) {
    super(metadata, inputs)
  }

  abstract getInnerSql(
    componentSQLParams: WorkflowComponentCodeParams
  ): string | null

  async getCode(
    componentCodeParams: WorkflowComponentCodeParams
  ): Promise<QueryAndOutputs | null> {
    const { workflow, params, connection, componentName, codeType } =
      componentCodeParams
    const preparedParams = this._prepareParameters(params)
    const select = this.getInnerSql({
      ...componentCodeParams,
      params: preparedParams
    })
    if (select !== null) {
      const tablename = connection.getOutputTableName(
        workflow.id,
        componentName,
        params,
        SINGLE_OUTPUT_NAME,
        codeType
      )
      let query = ''
      query = connection.getCreateTempTableQuery(
        tablename,
        dedent(select),
        codeType,
        null
      )
      return {
        query,
        outputs: { result: tablename }
      }
    } else {
      return null
    }
  }
}
